import React, { useState, useEffect } from "react";
import "../css/toast.scss";

const Toast = ({ message, show, onClose, confirmProps }) => {
  // For modal confirm we need local state for checkbox / input
  const [checked, setChecked] = useState(false);
  const [typed, setTyped] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      // reset when opened
      setChecked(false);
      setTyped("");
    }
  }, [show]);

  if (!show) return null;

  const handleConfirm = async () => {
    if (confirmProps && confirmProps.onConfirm) {
      try {
        setLoading(true);
        await confirmProps.onConfirm();
      } finally {
        setLoading(false);
      }
    }
    if (onClose) onClose();
  };

  const handleCancel = () => {
    if (confirmProps && confirmProps.onCancel) {
      confirmProps.onCancel();
    }
    if (onClose) onClose();
  };

  // validation for enabling confirm button
  const needsCheckbox = !!(confirmProps && confirmProps.showCheckbox);
  const requiredText = confirmProps && confirmProps.requireConfirmText;
  const confirmDisabled =
    (needsCheckbox && !checked) ||
    (requiredText && String(typed).trim() !== String(requiredText).trim());

  // Render confirm modal when confirmProps exists, otherwise render simple message box
  if (confirmProps) {
    return (
      <div
        className={`toast-overlay ${show ? "show" : ""}`}
        style={{ background: "rgba(0,0,0,0.35)" }}
        onClick={handleCancel}
      >
        <div
          className="toast-modal"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
        >
          <button
            className="toast-close-btn"
            aria-label="Close"
            onClick={handleCancel}
          >
            ×
          </button>

          <h3 className="toast-title">{confirmProps.title || "Confirm"}</h3>

          <div className="toast-modal-body">
            {confirmProps.showCheckbox && (
              <label className="confirm-checkbox">
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                />
                <span>{confirmProps.checkboxLabel || ""}</span>
              </label>
            )}

            {confirmProps.requireConfirmText && (
              <div className="confirm-input-row">
                <label className="confirm-input-label">
                  {confirmProps.confirmTextPlaceholder ||
                    `Enter '${confirmProps.requireConfirmText}' to confirm`}
                </label>
                <input
                  className="confirm-input"
                  value={typed}
                  onChange={(e) => setTyped(e.target.value)}
                  placeholder={confirmProps.confirmInputPlaceholder || ""}
                />
              </div>
            )}

            {confirmProps.description && (
              <p className="toast-desc">{confirmProps.description}</p>
            )}
          </div>

          <div className="toast-modal-actions">
            <button className="btn-ghost" onClick={handleCancel}>
              {confirmProps.cancelLabel || "Cancel"}
            </button>
            <button
              className="btn-primary"
              onClick={handleConfirm}
              disabled={confirmDisabled}
            >
              {loading ? <span className="btn-spinner" /> : null}
              {confirmProps.confirmLabel || "Delete"}
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Simple centered notification (non-confirm)
  return (
    <div className={`toast-overlay ${show ? "show" : ""}`} onClick={onClose}>
      <div className="toast-container" onClick={(e) => e.stopPropagation()}>
        <div className="toast-content">{message}</div>
      </div>
    </div>
  );
};

export default Toast;
